module.exports = {
      id: "icons:envelope-outline-usage",
      viewBox: "0 0 24 24",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:envelope-outline-usage",
      toString: function () {
        return this.url;
      }
    }